import clsx from 'clsx';
import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { TemplateLiteralValueFieldMetaProps } from './interfaces/template-form-literal-value-field-meta';
import { getDataIdGenerator } from '../../../shared/utils/dataId';
import { CopyToClipboardButton } from '../../../button/CopyToClipboardButton/CopyToClipboardButton';
import styles from './styles.module.scss';

export function TemplateLiteralValueField({ metadata }: TemplateFormFieldProps) {
  const dataIdGenerator = getDataIdGenerator('literal-value-field');

  const { className, displayName, value } = metadata as TemplateLiteralValueFieldMetaProps;

  return (
    <div className={clsx(styles.templateLiteralValueField, className)}>
      <div className=' d-flex gap-1 align-items-center w-100'>
        <span className='text-bold'>{displayName}: </span>
        <span className='text-secondary text-ellipsis w-50'>{value}</span>
      </div>

      <CopyToClipboardButton
        copyText={value}
        toastMessage={`${displayName} copied to clipboard`}
        dataId={dataIdGenerator('')}
        size='md'
      />
    </div>
  );
}
